class GBBrandStrip extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.setAttribute('data-ready', '');
    this.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') this.setAttribute('data-touching', '');
    }, { signal });
    const release = () => this.removeAttribute('data-touching');
    window.addEventListener('pointerup', release, { signal });
    window.addEventListener('pointercancel', release, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('gb-brand-strip')) {
  customElements.define('gb-brand-strip', GBBrandStrip);
}
